type PropType = {
  icon: string;
  iconBg: string;
  head: String;
  text: string;
  list: string[];
};
const FeaturesCard = ({ head, icon, iconBg, list, text }: PropType) => {
  return (
    <div className="flex gap-4">
      <div
        className="rounded-md p-4 aspect-square w-20 h-20 flex items-center justify-center"
        style={{ backgroundColor: iconBg }}
      >
        <img src={icon} alt="" className="w-14" />
      </div>
      <div className="flex flex-col items-start gap-4">
        <h1 className="text-black text-2xl font-semibold">{head}</h1>
        <div className="text-black flex flex-col sub text-sm">
          <h3>{text}</h3>
          <h3>
            {list.map((it, index) => (
              <ul key={index} className="list-disc pl-4 leading-7">
                <li>{it}</li>
              </ul>
            ))}
          </h3>
        </div>
      </div>
    </div>
  );
};

export default FeaturesCard;
